<template>
  <div class="motorconfig-picker" :class="{ mobile: device === 'mobile' }">
    <div class="toggle-container">
      <span class="heading">{{ $t('motor.list.recommendedTitle') }}</span>
      <form class="radio-container">
        <input type="radio" :value="1" v-model="motorFilter" name="filter" id="recommended"
               checked="checked">
        <label for="recommended">
          {{ $t('motor.list.recommended') }}
        </label>
        <input type="radio" :value="2" v-model="motorFilter" name="filter" id="all">
        <label for="all">
          {{ $t('motor.list.viewAll') }}
        </label>
      </form>
    </div>
    <div class="motorconfig-table">
      <div class="table-header">
        <div class="selection">{{ $t('motor.list.select') }}</div>
        <div class="cc" @click="sort('cm_rev')" :class="[sortBy === 'cm_rev' ? sortDirection : '']">CC</div>
        <div class="brand" @click="sort('brand')" :class="[sortBy === 'brand' ? sortDirection : '']">Merk</div>
        <div class="type" @click="sort('motor_type_id')" :class="[sortBy === 'motor_type_id' ? sortDirection : '']">
          {{ $t('motor.list.type') }}
        </div>
        <div class="continuous-nm" @click="sort('continuous_flow')"
             :class="[sortBy === 'continuous_flow' ? sortDirection : '']">{{ $t('motor.list.continuous') }}
        </div>
        <div class="max-nm" @click="sort('max_torque')" :class="[sortBy === 'max_torque' ? sortDirection : '']">{{ $t('motor.list.maxTorque') }}</div>
        <div class="max-rpm" @click="sort('max_rpm')" :class="[sortBy === 'max_rpm' ? sortDirection : '']">{{ $t('motor.list.maxRpm') }}</div>
        <div class="outgoing-as" @click="sort('outgoing_as')" :class="[sortBy === 'outgoing_as' ? sortDirection : '']">{{ $t('motor.list.as') }}</div>
        <div class="supply" @click="sort('stock')" :class="[sortBy === 'stock' ? sortDirection : '']">{{ $t('motor.list.deliveryTime') }}</div>
        <div class="price" @click="sort('price')" :class="[sortBy === 'price' ? sortDirection : '']">{{ $t('motor.list.price') }}
        </div>
      </div>
      <div class="motor-list" :class="{'overflow-hidden': noScroll}">
        <motor-item @openModal="$emit('openModal')" :motor="motor" v-for="(motor) in sortedMotors" :key="`motor${motor.id}`"></motor-item>
      </div>
    </div>
  </div>
</template>

<script>
import PopupInvoice from '@/components/popup/PopupInvoice';
import { mapGetters } from 'vuex';
import MotorItem from '@/components/motor/components/MotorItem';

export default {
  name: 'MotorList',

  components: {
    MotorItem,
    PopupInvoice,
  },

  data() {
    return {
      invoicePopup: false,
      noScroll: false,
      sortBy: null,
      sortDirection: 'asc',
      motorFilter: 1,
    };
  },

  computed: {
    ...mapGetters({
      device: 'getDevice',
      motors: 'build/motorConfig/getAllMotors',
      preferences: 'build/motorConfig/getMotorPreferences',
    }),
    sortedMotors() {
      return this.filteredMotors.sort((p1,p2) => {
        let modifier = 1;
        if(this.sortDirection === 'desc') modifier = -1;
        if(p1[this.sortBy] < p2[this.sortBy]) return -1 * modifier;
        if(p1[this.sortBy] > p2[this.sortBy]) return modifier;
        return 0;
      });
    },
    filteredMotors() {
      let motors = this.motors;
      let cc = this.preferences.cc;
      let type = this.preferences.selectedMotorType;
      let selectedMotor = this.preferences.selectedMotor;

      if (this.motorFilter === 2) {
        return [...motors];
      }

      if (cc !== 0) {
        let sortedMotors = motors.filter(function(motor) {
          let deviationPercentage = 30;
          let ccLowEndToMatchWithDeviation = parseInt(cc) - ((deviationPercentage / 100) * cc);
          let ccTopEndToMatchWithDeviation = parseInt(cc) + ((deviationPercentage / 100) * cc);
          return motor.cm_rev >= ccLowEndToMatchWithDeviation && motor.cm_rev <= ccTopEndToMatchWithDeviation ||
            motor.id === selectedMotor;
        });
        if (type !== null && type !== 0) {
          sortedMotors = sortedMotors.filter(function(motor) {
            return motor.motor_type.id === type;
          });
        }

        return sortedMotors;
      }
      if (type !== null && type !== 0) {
        let sortedMotors = motors.filter(function(motor) {
          return motor.motor_type.id === type;
        });
        if (sortedMotors.length !== 0) {
          this.$store.commit('build/motorConfig/selectMotor', sortedMotors[0].id);
        }

        return sortedMotors;
      }

      return [...motors];
    },
  },

  methods: {
    sort: function(s) {
      if (s === this.sortBy) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      }
      this.sortBy = s;
    },
  },
};
</script>

<style lang="scss">
.motorconfig-picker {
  &.mobile {
    margin: 0;

    .motorconfig-table {
      overflow-x: auto;
      overflow-y: hidden;
      margin-bottom: 24px;
      min-width: 100%;

      .table-header {
        min-width: 1100px;
      }

      .motor-list {
        min-width: 1100px;
        overflow-y: unset;
      }
    }
  }

  .heading {
    font-size: 12px;
    padding: 16px 20px 5px 15px;
    font-family: neue-haas-grotesk-display, sans-serif;
    font-style: normal;
    font-weight: 700;
    /*box-shadow: 0 0 10px #d3d3d3;*/
  }

  .more {
    width: 100%;
    text-align: center;
    margin-top: 10px;

    .link {
      text-decoration: underline;
      padding: 10px 10px 0 0;
      cursor: pointer;
      transition: all ease 0.2s;

      &:hover {
        color: #3DB0C7;
      }
    }

    .icon {
      transform: scale(1.2) rotate(90deg);
    }
  }
}

.scrollable {
  margin: 0;
  width: 806px;

  .invoice {
    background-color: #d2d2d2;
  }
}

.motorconfig-table {
  background: #f0f0f0;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .1), 0 1px 2px 0 rgba(0, 0, 0, .06);
  font-size: 12px;
  position: relative;
  margin-top: 15px;
  overflow-x: auto;

  .table-header {
    div {
      &.cc,
      &.brand,
      &.type,
      &.max-nm,
      &.max-rpm,
      &.outgoing-as,
      &.continuous-nm,
      &.price,
      &.supply {
        cursor: pointer;
      }

      &.asc:after {
        content: "\25B2";
        color: #3DB0C7;
      }

      &.desc:after {
        content: "\25BC";
        color: #3DB0C7;
      }
    }
  }

  .table-header,
  .motor-row {
    display: grid;
    grid-template-columns: 60px 85px 65px 160px 97px 88px 112px 50px 83px 118px auto;

    .download-link {
      border: none !important;
      background: transparent !important;
      display: inline-block;
      position: relative;
      right: 15%;
      cursor: pointer;
      transition: all ease 0.3s;

      &:hover {
        transform: scale(1.1);
        filter: brightness(200%);
      }

      img {
        max-height: 24px;
        max-width: 24px;
      }
    }

    .selection,
    .cc,
    .brand,
    .type,
    .max-rpm,
    .outgoing-as,
    .max-nm,
    .continuous-nm,
    .supply,
    .amount-table,
    .price {
      padding: 5px 3px;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
      border-right: 2px solid #e0e0e0;
    }

    .amount-table {
      border-right: none;

      .amount-switch {
        border-radius: 50px;
        border: 2px solid #EBEBEB;
        height: 28px;
        font-size: 12px;
        display: flex;
        align-items: center;
        padding: 0 4px;
        width: 80px;
        position: relative;
        background-color: white;
        user-select: none;
        transition: all ease 0.3s;
        justify-content: space-between;

        .add, .subtract {
          transform: scale(1);
          color: #3DB0C7;
          transition: all ease 0.2s;

          &:hover {
            transform: scale(1.4);
          }
        }

        .subtract {
          margin-bottom: 2px;
        }

        input {
          border: none;
          font-size: 12px;
          font-family: "Neue Haas Grotesk Display Pro", sans-serif;
          width: 30px;
          height: auto;

          &:focus {
            outline: none;
          }
        }
      }
    }

    .attachment {
      .cilinder-render {
        max-width: 100%;
        height: auto;
        position: relative;
        left: 10%;
        mix-blend-mode: multiply;
      }
    }

    .cart-action,
    .actions {
      display: flex;
      align-items: center;
      padding: 3px 3px;
      margin-left: 10px;

      .btn {
        color: white;
        padding: 3px 10px !important;
        font-size: 11px;
        height: 24px;
        border-radius: 15px;
        font-weight: bold;
        border: transparent;

        &.btn-success {
          background: #71bc03;

          &:hover {
            background: darken(#71bc03, 10%);
          }
        }

        &.blue {
          background: #3db0c7;
          flex-grow: 1;
          margin-right: 10px;

          &:hover {
            background: darken(#3db0c7, 10%);
          }

          &.active {
            background-color: darken(#3db0c7, 15%);
          }
        }

        img {
          max-height: 13px;
          max-width: 13px;
          margin-right: 5px;
        }
      }
    }
  }

  .table-header {
    background: #f5f5f5;
    font-family: neue-haas-grotesk-display, sans-serif;
    font-size: 11px;
    font-weight: 700;
  }

  .custom-cilinder {
    .custom-label {
      grid-column-start: 1;
      grid-column-end: 9;
      padding: 15px;
      background: #e0e0e0;
      text-align: center;
    }

    .cart-action {
      background: #e0e0e0;
      text-align: center;

      button.btn {
        min-width: 175px;
      }
    }
  }

  .motor-list {
    max-height: 320px;
    overflow-y: auto;
    position: relative;

    .motor-row {

      &:nth-child(odd) {
        background-color: #F0F0F0;

        &.selected {
          background-color: lighten(#3db0c7, 30%);
        }
      }

      &:nth-child(even) {
        background-color: #F5F5F5;

        &.selected {
          background-color: lighten(#3db0c7, 30%);
        }
      }
    }
  }

  &:after {
    content: "";
    position: absolute;
    display: block;
    height: 10px;
    bottom: 0;
    left: 0;
    right: 0;
    background-image: linear-gradient(transparentize(#e0e0e0, 1), transparentize(#e0e0e0, 0.5));
  }
}

.toggle-container {
  align-items: center;
  text-align: center;
  justify-content: space-between;
  height: 50px;
  display: flex;

  .heading {
    padding: 0;
  }

  .radio-container {
    border-radius: 50px;
    border: 2px solid #EBEBEB;
    height: 40px;
    width: 300px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    background-color: white;
    transition: all ease 0.3s;

    @media only screen and (max-width: 375px) {
      label {
        white-space: nowrap;
      }
    }

    label {
      cursor: pointer;
      display: flex;
      justify-content: center;
      font-size: 12px;
      margin: 0;
      border-radius: 25px;
      width: 50%;
      padding: 9px;
      user-select: none;
      font-family: neue-haas-grotesk-display, sans-serif;
    }

    input[type="radio"] {
      display: none;


      &:checked + label {
        background-color: #3DB0C7;
        color: white;
      }
    }
  }
}

</style>
